export default __webpack_public_path__ + "static/media/github-logo.37185c9c.png";